var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import ReactHtmlParser, { convertNodeToReactElement, } from "@hedgedoc/html-to-react";
import { Link } from "../link";
export const InnerHtml = React.forwardRef((_a, ref) => {
    var { content, type = "primary" } = _a, props = __rest(_a, ["content", "type"]);
    const transform = (node, index) => {
        if (node.type === "tag" && node.name === "a") {
            const { attribs: { target, href, class: className }, children, } = node;
            return (_jsx(Link, { target: href, text: children && children[0] && children[0].data, windowTarget: target, stylingType: type, ref: ref, hasArrow: className === null || className === void 0 ? void 0 : className.includes("arrow"), className: className, inContext: true, standardFontSize: true }));
        }
        return convertNodeToReactElement(node, index, transform);
    };
    if (!content)
        return _jsx(_Fragment, {});
    let html = content;
    // generate react html
    html = ReactHtmlParser(content, {
        decodeEntities: true,
        transform,
    });
    const Element = props.as || "p";
    return (_jsx(Element, Object.assign({}, props, { className: `gdds-element ${props.className}` }, { children: html })));
});
InnerHtml.displayName = "InnerHtml";
